<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="headline">Selecionar Relatórios:</v-card-title>
      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            label="Procurar"
            hide-details
            single-line
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            v-model="relatoriosSelecionados"
            :headers="headers"
            :items="relatorios"
            :items-per-page="itemsPerPage"
            :search.sync="search"
            :page.sync="currentPage"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            no-data-text="Nenhum relatório disponível"
            :mobile-breakpoint="0"
            class="mx-10"
            item-key="id"
            show-select
          >
            <template v-slot:[`item.nome`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="text-truncate" style="max-width: 220px" v-bind="attrs" v-on="on">{{ item.nome }}</div>
                </template>
                <span>{{ item.nome }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="text-truncate" style="max-width: 120px" v-bind="attrs" v-on="on">{{ item.usuario }}</div>
                </template>
                <span>{{ item.usuario }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.numero_registros`]="{ item }">
              {{ item.numero_registros | parseNumberToIntegerBR }}
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getRelatoriosStatusSucesso">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar os relatórios</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-card-actions class="d-flex justify-space-between pb-4 px-6">
        <v-btn text color="error" @click="$emit('update:activated', false)">Cancelar</v-btn>
        <v-btn color="primary" @click="confirmarSelecao">Aplicar seleção</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService';

  export default {
    name: 'DialogSeletorRelatorioTarefas',

    props: {
      activated: {
        type: Boolean,
        required: true
      },
      selecionados: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Nome', value: 'nome' },
        { text: 'Usuário', value: 'usuario' },
        { text: 'Linhas', value: 'numero_registros' }
      ],
      relatorios: [],
      relatoriosSelecionados: [],
      loading: false
    }),

    computed: {
      dialog() {
        return this.activated;
      }
    },

    created() {
      this.getRelatoriosStatusSucesso();
    },

    methods: {
      getRelatoriosStatusSucesso() {
        this.loading = true;

        RelatoriosService.getRelatoriosByStatus('sucesso')
          .then((response) => {
            this.relatorios = response.data.data;
            this.sincronizarSelecionados();
          })
          .catch(() => this.$toast.error('Erro ao recuperar relatorios com status sucesso.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      },

      confirmarSelecao() {
        this.$emit(
          'selected',
          this.relatoriosSelecionados.map(({ id, nome }) => ({ id, nome }))
        );
        this.search = '';
      },

      sincronizarSelecionados() {
        const idsSelecionados = new Set(this.selecionados.map((relatorio) => relatorio.id));
        this.relatoriosSelecionados = this.relatorios.filter((relatorio) => idsSelecionados.has(relatorio.id));
      }
    },

    watch: {
      search() {
        this.currentPage = 1;
      },
      selecionados: {
        deep: true,
        handler() {
          this.sincronizarSelecionados();
        }
      }
    }
  };
</script>
